var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 29.333c7.3638 0 13.333-5.9696 13.333-13.333 0-0.6169-0.9247-0.7189-1.2438-0.1909-1.5177 2.5117-4.2742 4.1909-7.4229 4.1909-4.7865 0-8.6667-3.8801-8.6667-8.6666 0-3.1488 1.6792-5.9053 4.191-7.423 0.528-0.31906 0.426-1.2437-0.191-1.2437-7.3638 0-13.333 5.9695-13.333 13.333 0 7.3638 5.9695 13.333 13.333 13.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoon);
export default __webpack_public_path__ + "static/media/icon_moon.1a1751e1a1554766592d088f7988bce8.svg";
export { ForwardRef as ReactComponent };